// extracted by mini-css-extract-plugin
export default {"container":"ShipmentEventsLine_container__xco12","eventsOuterContainer":"ShipmentEventsLine_eventsOuterContainer__wKGGz"};